<iframe
  #kibana
  height="1000px"
  width="100%"
></iframe>
